import { Paper, Typography } from '@mui/material';
import { EventCard } from '@scorenco/components';
import { Types, useTranslation } from '@scorenco/core';

import { T_KEYS } from '@/translations';

type LastEventProps = {
  event: Types.Competitions_Event_Detail;
};

export const LastEvent = ({ event }: LastEventProps) => {
  const { t } = useTranslation();

  return (
    <Paper variant="bordered" sx={{ mb: 4 }}>
      {event?.status === 'live' && (
        <Typography
          variant="h3"
          gutterBottom
          sx={{ textTransform: 'uppercase' }}
        >
          {t(T_KEYS.LIVE_MATCH)}
        </Typography>
      )}

      <EventCard event={event} />
    </Paper>
  );
};
